import { trigger, transition, style, animate } from '@angular/animations';

// Hier definieren wir unsere Animationen als Funktionen, die exportiert werden.
export const fadeSlideInOut = trigger('fadeSlideInOut', [
  transition(':enter', [
    style({ height: '0px', opacity: 0, transform: 'translateY(-10px)' }),
    animate('300ms 300ms ease-out', 
      style({ height: '*', opacity: 1, transform: 'translateY(0)' })
    ),
  ]),
  transition(':leave', [
    animate('300ms ease-in', 
      style({ height: '0px', opacity: 0, transform: 'translateY(-10px)' })
    ),
  ]),
]);

export const fadeIn = trigger('fadeIn', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('300ms ease-out', style({ opacity: 1 }))
  ])
]);

export const slideIn = trigger('slideIn', [
  transition(':enter', [
    style({ transform: 'translateY(-100%)' }),
    animate('300ms ease-out', style({ transform: 'translateY(0)' }))
  ])
]);
